import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Box, Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import { useResponsive } from '~/client-flow/contexts';
import BankSecurityRow from '~/components/BankSecurityRow/BankSecurityRow';
import ManagePaymentMethods from '~/components/ManagePaymentMethods/ManagePaymentMethods';
import { useStore } from '~/contexts';
import { relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { usePaymentMethodContext } from '../../../hooks/usePaymentMethodSelection';
import styles from './PaymentMethod.module.scss';
export const GetPaymentMethodTID = ()=>getTestIds();
export const PaymentMethod = ()=>{
    const { relationship, isPreview } = useCobConfig();
    const { isMobile } = useResponsive();
    const isVendor = useStore(selectors.user.isVendor);
    const isMemberClient = useStore((s)=>selectors.user.isMemberUser(s) && selectors.user.isClient(s));
    const { selectedPaymentMethod, onSelectPaymentMethod } = usePaymentMethodContext();
    const { PaymentMethodTestIds } = useMemo(()=>GetPaymentMethodTID(), []);
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.root,
        children: /*#__PURE__*/ _jsxs(Column, {
            className: cn(styles.inner, {
                [styles.innerMobile]: isMobile
            }),
            testId: PaymentMethodTestIds.Root(),
            gap: 24,
            children: [
                /*#__PURE__*/ _jsx(ManagePaymentMethods, {
                    isProposal: true,
                    vendorId: relationshipModel.vendor(relationship),
                    customerId: relationshipModel.customer(relationship),
                    showCreditCardFee: !relationshipModel.actualIsVendorCoveringCCFee(relationship),
                    isVendorCoveringFees: relationshipModel.actualIsVendorCoveringCCFee(relationship),
                    isPreview: isPreview,
                    isSample: relationshipModel.isSample(relationship),
                    isMemberClient: isMemberClient,
                    isInviteMemberDisabled: isVendor || relationshipModel.isSample(relationship) || isPreview,
                    hideInviteMemberHint: isMobile,
                    onSelectPaymentMethod: (pm)=>{
                        onSelectPaymentMethod(pm ? {
                            id: pm.id,
                            type: pm.type,
                            last4: pm.last4,
                            fundingSourceId: pm.id
                        } : undefined);
                    },
                    relationshipId: relationshipModel.id(relationship),
                    initialSelectedPaymentMethodId: selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.fundingSourceId
                }),
                !isMobile && /*#__PURE__*/ _jsx(BankSecurityRow, {
                    "data-testid": PaymentMethodTestIds.BankSecurityRow()
                })
            ]
        })
    });
};
